import React from 'react';
import { X } from 'lucide-react';
import QuestionRenderer from '../../pages/quiz/components/QuestionRenderer';
import QuizQuestionTitle from './QuizQuestionTitle';

interface Question {
  id: string;
  type: string;
  title: string;
  options: any[];
  score: number;
  titleImages?: string[];
  titleImageWidths?: number[];
  titleImageLayout?: string;
  imagePosition?: string;
  optionLayout?: string;
  optionImageWidths?: Record<string, number>;
  [key: string]: any;
}

interface QuestionPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  question: Question;
}

const QuestionPreviewModal: React.FC<QuestionPreviewModalProps> = ({
  isOpen,
  onClose,
  question
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* 头部 */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-bold text-gray-800">题目预览</h3>
          <button
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* 内容区 */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="bg-gray-50 rounded-lg p-6">
            {/* 题干渲染 - 使用 QuizQuestionTitle 以支持图片缩放 */}
            <QuizQuestionTitle
              question={question}
              currentIndex={0}
              examQuestions={[question]}
            />
            {/* 选项和答案区域 */}
            <QuestionRenderer
              key={question.id}
              question={question}
              currentIndex={0}
              answers={{}}
              isSubmitted={false}
              isPreview={true}
              paperId=""
              currentUser={null}
              aiExplanations={{}}
              examQuestions={[question]}
              aiGradingEnabled={true}
              isAssignmentMode={false}
              onAnswerChange={() => {}}
              onTextAnswerChange={() => {}}
              onAIGrading={async () => ''}
              onExamQuestionsChange={() => {}}
              onHasWidthChangesChange={() => {}}
            />
          </div>
        </div>

        {/* 底部 */}
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <p className="text-xs text-gray-500 text-center">
            以上为学员端显示效果预览
          </p>
        </div>
      </div>
    </div>
  );
};

export default QuestionPreviewModal;
